<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    凤凰城站<br>
站点介绍<br>
凤凰城站位于光明大道和观光路交叉路口以南、车站东西两侧以商业和居住用地为主、北侧为光明新区管委会、南侧为光明德源建材物流中心、西侧为深圳市特区建设发展集团有限公司开发的光明平板显示园总部基地综合体项目、东侧为政府储备用地、道路与东西两侧地块为斜坡式连接。车站位置路中央设14m宽绿化带，区间位置路中5m宽绿化带。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:00	23:26	6号线	3分24秒	6分20秒<br>
松岗	06:00	23:45	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:07	23:26	6号线	4分45秒	6分钟<br>
松岗	06:00	23:45	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:07	00:26	6号线	4分45秒	6分钟<br>
松岗	06:00	00:45	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
光明大道东侧（南）、玖龙台，光明蓝鲸世界<br><br>
B出入口:<br>
光明大道东侧（北）、光明区市民广场、深圳实验学校、光明文化艺术中心、光明区图书馆，光明区政府<br><br>
C出入口:<br>
光明大道西侧（北），特区建发乐府广场<br><br>
D出入口:<br>
光明大道西侧（南），开明公园，特区建发乐府广场<br><br>
公交换乘信息<br><br>
A/B出入口:<br>
公交站名： 凤凰城地铁站<br>
M337,M356,M387,M451,M525,M529,高峰专线167，A6,B967,B971,E39,M206,高快巴士33，虹桥公园假日专线1<br><br>
C/D出入口:<br>
公交站名： 凤凰城地铁站<br>
B967、M356,M387,M451,M525,M529,高峰专线167,虹桥公园假日专线1,A6,B884,B971,E39,M206,M337,高快巴士33.<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>